import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
@Injectable()
export class SaHelpVideoService {

  constructor(private http: HttpClient) { }
  getAllVideosNCategories() {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/VideoMgm/getAllVideosNCategories');
  }

  addCategory(id,name) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/VideoMgm/addCategory', {id:id, name: name });
    // return this.http.get(globalAdd.Paneladdress + 'api/SA/VideoMgm/addCategory?id=' + id + '&name=' + name);
  }
  addVideo(videoModel) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/VideoMgm/addVideo', { videoModel: JSON.stringify(videoModel) });
    // return this.http.get(globalAdd.Paneladdress + 'api/SA/VideoMgm/addVideo?videoModel='+ JSON.stringify(videoModel) );
  }

  deleteHelpVideo(id) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/VideoMgm/deleteHelpVideo', { id: id });
    // return this.http.get(globalAdd.Paneladdress + 'api/SA/VideoMgm/deleteHelpVideo?id='+id);
  }
  deleteVideoCategory(id) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/VideoMgm/deleteVideoCaegory', { id: id });
    // return this.http.get(globalAdd.Paneladdress + 'api/SA/VideoMgm/deleteVideoCaegory?id='+ id);
  }

}
